import React from 'react';
import {connect} from 'react-redux';
import {injectIntl} from "react-intl";

import MobileNavigationCommon from "../../visComponents/navigation/mobileNavigationCommon";

import {ContentType} from "../../visComponents/constants";
import Z from "../core/zIndex";

import MobileNavigationButtons from '../../visComponents/navigation/mobile/mobileNavigationButtons';
import MobileNavigationAllWallsCheckbox from '../../visComponents/navigation/mobile/mobileNavigationAllWallsCheckbox';
import FeatureWizardSteps from "../../visComponents/navigation/featureWizard/featureWizardSteps";

import {changeActivePartRelatedItemIndex, setDefaultSelectionGroup} from "../../../actions/actionFunctions";
import {
  setActiveNavigationFilter,
  setModuleContextMenuType,
  setModuleContextMenuModule,
  setActiveNavigationFilterStepIndex, setNavigationViewType, setNavigationLoading
} from "../../../actions/navigationFunctions";

import MobileMenuSelect from '../../visComponents/navigation/mobile/mobileMenuSelect';
import LockedView from "../../common/lockedView";

import Filters from "../../visComponents/navigation/newFilters/filters";
import BodyPanelRadio from "../../visComponents/navigation/desktop/bodyPanelRadio";
import FilterSwitchers from "../../visComponents/navigation/newFilters/filterSwitchers";
import FilterSelection from "../../visComponents/navigation/newFilters/filterSelection";
// import {CABINET_WIZARD_BUTTONS} from "../core/constants";
import NavigationFiltersSteps from "../../visComponents/navigation/newFilters/navigationFiltersSteps";
import ContextMenuSimple from "./contextMenuSimple";

import {getCurrentLayout} from "../../appLayout";

class MobileNavigation extends MobileNavigationCommon {

  UNSAFE_componentWillReceiveProps(nextProps) {
    this._UNSAFE_componentWillReceiveProps(nextProps)
  }

  bindCanvasClick = (event) => {
    // console.log("bindCanvasClick event");

    if (!window.touchMove && !this.state.showNavigation && !this.state.contextMenuOpen) {
      this.props.setHoveredLayer(event);
    }

    if (document.hoveredLayer && !window.touchMove) {
      // $('.canvas-text').html(`CLICK3`);
      const hoveredZone = Z.getMenuByHoveredLayer(document.hoveredLayer);
      if (hoveredZone) {
        if (hoveredZone.contextMenuPartId && !this.state.showNavigation) {
          if (this.state.contextMenuOpen) {
            this.setState({
              contextMenuOpen: false,
              hoveredLayer: {}
            });
            document.removeEventListener('click', this.handleContextMenuBlur);
          } else {
            let contextMenuOpen = "";

            const receiveBackSplashes = () => {
              const layout = getCurrentLayout();
              const wallsParent = layout.parts["Walls"];
              const backsplashSubPart = wallsParent.subParts().find(subPart => subPart.part.partId === "backsplash");
              this.checkIfAllFeaturesReceived(backsplashSubPart);
            };

            switch (hoveredZone.contextMenuPartId) {
              case "countertop_group_custom":
                contextMenuOpen = "Countertop";
                break;
              case "right_wall_custom":
                contextMenuOpen = "right_wall_custom";
                break;
              case "left_wall_custom":
                contextMenuOpen = "left_wall_custom";
                break;
              case "backsplash_custom_left": {
                receiveBackSplashes();
                contextMenuOpen = "backsplash_custom_left";
                break;
              }
              case "backsplash_custom_right": {
                receiveBackSplashes();
                contextMenuOpen = "backsplash_custom_right";
                break;
              }
              case "backsplash_custom": {
                receiveBackSplashes();
                contextMenuOpen = "backsplash_custom";
                break;
              }
              case "center_island_custom":
                contextMenuOpen = "Center Island";
                break;
              default:
                break;
            }
            this.setState({
              contextMenuOpen: contextMenuOpen || hoveredZone,
              hoveredLayer: document.hoveredLayer
            }, () => {
              if (contextMenuOpen) {
                setTimeout(() => {
                  document.addEventListener('click', this.handleContextMenuBlur);
                }, 0)
              }
            });
          }
          return false;
        } else if (this.state.contentType === 0) {
          if (!window.canvasIsDragging) {
            this.props.setCanvasClass((hoveredZone.child || hoveredZone.parent || hoveredZone).toLowerCase().replace(/ /g, "-"));
          }
          this.openMobileMenu();
        }

        hoveredZone.child
          ? this.triggerOpenNavigationMenu(hoveredZone.child, hoveredZone.parent, false)
          : this.triggerOpenNavigationMenu(hoveredZone)

      }

    }

  };

  handleNavigationItemClick = (item, ignoreLocked = false) => {

    if (window.location.port === '9007' || document.kvConfig.kioskMode) {
      console.log('item', item);
    }
    this.itemClick(item, ignoreLocked);

    this.props.setActiveFeature(item.part);

    const canvasClass = this.state.childNavigationItem
      ? this.state.parentNavigationItem.text + '-' + this.state.childNavigationItem.text
      : this.state.parentNavigationItem.text;

    if (!window.canvasIsDragging) {
      this.props.setCanvasClass(canvasClass.toLowerCase().replace(/ /g, "-"));
    }

    if (this.state.parentNavigationItem) {  // update canvas only if it is child
      this.props.refreshCB();
    }
    if (item.part.partId === "top_cabinet" && !item.part.metaData["Module"]) {
      this.props.setModuleContextMenuModule(null)
    }
  };

  handleSubPartClick = (subNavigationItem, activeNavigationFilter = null) => { // sidebar list item click
    const subItemPart = subNavigationItem.part;
    const childNavigationItemPartId = subItemPart.partId;
    subItemPart.getParent().handleSubPartClick(subItemPart);
    this.setState({
      childNavigationItem: subNavigationItem,
      showFilterSelection: subItemPart.allFeaturesReceived, // show filters only if subItemPart has all features
      showerWallWizardGroupsSelected: false,
      searchText: ""
    }, () => {
      this.scrollContentToTop();
      this.rememberWallsSelection();
      this.checkIfAllFeaturesReceived(subNavigationItem, "childNavigationItem");
    });
    /*set new materials page subIndex*/
    this.setActivePartRelatedItemIndex(subNavigationItem);
    // console.log('subItemPart', subItemPart);
    if (!window.canvasIsDragging) {
      const canvasClass = this.state.parentNavigationItem.text + '-' + subNavigationItem.text
        .toLowerCase().replace(/ /g, "-");
      this.props.setCanvasClass(canvasClass);
    }
    this.setNewActiveFeature(subNavigationItem);

    this.setNavigationFilterIfTheChildWasChanged(childNavigationItemPartId, activeNavigationFilter);

  };

  backsplashSelectClick = () => {
    this.props.refreshCB(); // update canvas
    this.reRenderComponent(); // update nav items
  };

  render() {
    const layout = getCurrentLayout();
    const activePart = this.state.parentNavigationItem ? this.state.parentNavigationItem.part : null;
    const activeSubPart = this.state.childNavigationItem ? this.state.childNavigationItem.part : null;
    const activeNavPart = activeSubPart || activePart;
    const parentItems = layout.designNavigationItems();  // parent list without filters
    const allFeaturesReceived = activeNavPart && activeNavPart.allFeaturesReceived;

    // console.log('activePart', activePart);
    // console.log('activeSubPart', activeSubPart);
    // console.log('activePart.subTypes()', activePart && activePart.subTypes());
    // console.log('this.state.childNavigationItemv1111', this.state.childNavigationItem);

    let useWizard = false;
    let wizardGroups = [];
    if (this.props.fabricatorSettings
      && (this.props.fabricatorSettings.wizardConsumers || (this.props.fabricatorSettings.wizardClients && document.kvConfig.isBackend))
      && this.state.contentType === ContentType.Design && activeSubPart && activeSubPart.canUseWizard && activeSubPart.allFeaturesReceived) {
      useWizard = true;
      wizardGroups = this.state[this.getWizardGroupsByPartId(this.state.childNavigationItem.part.partId)];
    }

    const features = this.getFeatures(layout);

    const showLockedView = this.currentActiveItemIsLocked(useWizard);

    const useFilters = (activePart && activePart.partId === "kitchen_floor" && activePart.allFeaturesReceived)
      || (activeSubPart && (this.isWallItem(activeSubPart) || activeSubPart.partId === "accent_wall"
        || activeSubPart.partId === "shower_interior_wall_accent") && activeSubPart.allFeaturesReceived);

    const filterSelectionHasValues = activeNavPart && FilterSelection.getAvailableFilterValues(
      this.props.filterGroups, "Material", activeNavPart, this.props.fabricatorData
    ).length;

    const itemIsSelected = (!this.props.fabricatorSettings.leadCapture
      || (activeSubPart && activeSubPart.activeFeature && activeSubPart.firstClick[this.props.activeQuoteIndex] && activeSubPart.placeholderChanged));

    const useKVWizard = false;
    //TODO change it when BE is ready

    const showNavigationFilters = useKVWizard &&activeNavPart
      // && this.props.activeNavigationFilter !== CABINET_WIZARD_BUTTONS[0].buttonId
      && activeNavPart.canUseNavigationFilter && activeNavPart.canUseNavigationFilter();

    let showNavigationFiltersSteps = false;
    if (useKVWizard && activeNavPart && activeNavPart.canUseNavigationFilterSteps
      && activeNavPart.canUseNavigationFilterSteps()) {
      showNavigationFiltersSteps = !this.props.countertopNavigationFilterCompleted;
    }

    const cabinetsPartIds = ["top_cabinet", "bottom_cabinet", "center_island_cabinet"];
    const isCabinet = activeSubPart && cabinetsPartIds.includes(activeSubPart.partId);
    const countertopPartIds = ["countertop", "backsplash", "center_island_countertop"];
    const isCountertop = activeSubPart && countertopPartIds.includes(activeSubPart.partId);

    return (
      <div className={"menu-wrapper"
      + (this.state.showNavigation || this.state.contextMenuOpen ? " menu-overlay--fullwidth" : "")}>
        <div className={"menu" + (this.state.showNavigation ? " menu--opened" : "")}>
          {/*<button className="menu-opener" onClick={this.toggleMobileMenu}/>*/}
          <div className={"menu-inner" + (this.state.searchInputFocused ? " menu-inner--search-input-focused" : "")}>
            <div className="menu-header">
              <div
                className={"menu-header__left"
                + (this.state.childNavigationItem ? " menu-header__left--with-border" : "")
                + (isCabinet ? " menu-header__left--with-cabinets" : "")
                + (isCountertop ? " menu-header__left--with-countertops" : "")}>
                {this.state.childNavigationItem && this.state.childNavigationItem.part.canBeDisabled ? (
                  <BodyPanelRadio updateRadio={this.state.updateRadio}
                                  isMobile={true}
                                  activeSubPart={this.state.childNavigationItem.part}
                                  handleRadioButtonClick={this.handleRadioButtonClick}/>
                ) : null}
                {activeSubPart && this.isWallItem(activeSubPart) && activeSubPart.partName !== "Accent Wall"
                  ? <MobileNavigationAllWallsCheckbox
                    parentNavigationItem={this.state.parentNavigationItem}
                    toggleApplyWallsCheckbox={this.toggleApplyWallsCheckbox}/>
                  : null}
              </div>
              <MobileNavigationButtons contentType={this.state.contentType}
                                       searchText={this.state.searchText}
                                       canvasId={this.props.canvasId}
                                       parentNavigationItem={this.state.parentNavigationItem}
                                       handleSearchInputChange={this.handleSearchInputChange}
                                       changeMessageBoxState={this.props.changeMessageBoxState}
                                       resetEverything={this.resetEverything}
                                       userIsLoggedIn={this.props.userIsLoggedIn}
                                       toggleUserPopup={this.props.toggleUserPopup}
                                       handleChangeContentType={this.handleChangeContentType}/>
            </div>
            {useFilters && this.state.showFilterSelection && filterSelectionHasValues
            && (this.state.contentType === ContentType.Design) ? (
              <FilterSelection removeFilterSelection={this.removeFilterSelection}
                               filterGroupName="Material"
                               activePart={activeNavPart}
                               isMobile={true}
              />
            ) : (
              this.state.showFeatureWizard ? (
                useWizard && this.state.childNavigationItem && this.state.childNavigationItem.part
                  ? this.contentDesignWizard()
                  : this.contentBody(features, showNavigationFilters || showNavigationFiltersSteps, useFilters, activePart, activeSubPart, filterSelectionHasValues, allFeaturesReceived)
              ) : this.contentBody(features, showNavigationFilters || showNavigationFiltersSteps, useFilters, activePart, activeSubPart, filterSelectionHasValues, allFeaturesReceived)
            )}
            {useWizard && !this.state.showFeatureWizard && !useFilters
            && (this.state.contentType === ContentType.Design) ? (
              <FeatureWizardSteps
                availableSteps={wizardGroups.filter(step => !step.hidden)}
                featureWizardStep={this.state.wizardStepIndex}
                setFeatureWizardStep={this.setWizardStepIndex}
                exitFeatureWizard={this.exitFeatureWizard}
                getFilterDisplayName={this.getFilterDisplayName}
                isMobile={true}
                isPhoneNumberValidated={this.props.isPhoneNumberValidated}
                allProducts={true}
                showFeatureWizard={this.state.showFeatureWizard}
                enableFeatureWizard={this.enableFeatureWizard}
                toggleWizardFilterSelection={this.toggleWizardFilterSelection}
                allStepsCompleted={wizardGroups.every(step => step.selectedValueId) || itemIsSelected}
              />
            ) : null}
            {showNavigationFilters || showNavigationFiltersSteps ? (
              <NavigationFiltersSteps
                activePart={activeNavPart}
                isMobile={true}
              />
            ) : null}
            {useFilters && !this.state.showFilterSelection && filterSelectionHasValues ? (
              <FilterSwitchers activePart={activeNavPart} filterGroupName="Material" isMobile={true}/>
            ) : null}
            {this.state.contentType === ContentType.Design && this.state.parentNavigationItem
            && !(useWizard || showNavigationFilters || showNavigationFiltersSteps || (useFilters && filterSelectionHasValues)) ? (
              <MobileMenuSelect parentItems={parentItems}
                                activePart={activePart}
                                activeSubPart={activeSubPart}
                                onSubPartClick={this.handleSubPartClick}
                                onParentItemClick={this.handleParentItemClick}/>
            ) : null}
          </div>
        </div>
        {this.state.contextMenuOpen && !this.state.contextMenuOpen.module
          ? <ContextMenuSimple contextMenuOpen={this.state.contextMenuOpen}
                               hoveredLayer={this.state.hoveredLayer}
                               handleContextMenuClick={this.handleContextMenuClick}
                               closeContextMenu={this.closeContextMenu}
                               renderGreenLayerByZindex={this.props.renderGreenLayerByZindex}
          />
          : null}
        {showLockedView
          ? <LockedView setActiveFeature={this.resetActiveFeature} handleUserLoginClick={this.handleUserLoginClick}/>
          : null}
        <Filters
          id="mobileNavigation"
          searchText={this.state.searchText}
          handleSearchInputChange={this.handleSearchInputChange}
          childItem={this.state.childNavigationItem}/>
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  fabricatorData: store.fabricatorState,
  selectedFilters: store.filterState.selectedFilters,
  filtersVisible: store.filterState.showFilters,
  filterGroups: store.filterState.filterGroups,
  bvPresets: store.bathroomVisualizerState.bvPresets,
  userPopupOpened: store.userState.userPopupOpened,
  activeNavigationFilter: store.navigationState.activeNavigationFilter,
  countertopNavigationFilterCompleted: store.navigationState.countertopNavigationFilterCompleted,
  newLayoutType: store.sqftState.newLayoutType,
  activeQuoteIndex: store.quotesState.activeQuoteIndex,
});

const mapDispatchToProps = {
  setNavigationViewType,
  setModuleContextMenuType,
  setDefaultSelectionGroup,
  changeActivePartRelatedItemIndex,
  setActiveNavigationFilter,
  setActiveNavigationFilterStepIndex,
  setModuleContextMenuModule,
  setNavigationLoading
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(MobileNavigation)
);
